import { render } from "./EOLGeneral.vue?vue&type=template&id=2f7962cb"
import script from "./EOLGeneral.vue?vue&type=script&lang=js"
export * from "./EOLGeneral.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__